module.exports = __webpack_public_path__ + "img/horizontal_4_1_0.14703829.png";